import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { EmergencyManagementService } from 'src/app/_services/emergency-management.service';
import { showNotification } from 'src/app/helpers/show-toast';
@Component({
  selector: 'app-emergency-management',
  templateUrl: './emergency-management.component.html',
  styleUrls: ['./emergency-management.component.scss']
})
export class EmergencyManagementComponent implements OnInit {

  pageTitle: string = 'Emergency Card Management';
  placeholder: string = 'Search by patient phone number…';
  tableTitle: string = 'Patients';

  patientList: any[] = [];
  filteredPatientList: any[];
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number;
  totalItems: number;
  phoneNumber = '';
  noMatchingResult: boolean = true;
  isSearchBtn: boolean = false;


  constructor(
    private emergencyManagementService: EmergencyManagementService,
    public toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.getAllPatients();
  }

  getAllPatients() {
    this.emergencyManagementService.getAllPatients(this.pageSize, this.currentPage)
      .subscribe({
        next: (response: any) => {
          this.noMatchingResult = false;
          this.patientList = response?.data?.items;
          this.filteredPatientList = [...this.patientList];
          if (!this.filteredPatientList.length) {
            this.noMatchingResult = true;
          }
          this.currentPage = response?.data?.pagination.currentPage;
          this.totalPages = response?.data?.pagination.totalPages;
          this.totalItems = response?.data?.pagination.totalItems;
        },
        error: (error) => {
          this.noMatchingResult = true;
          this.filteredPatientList = [];
        }
      });
  }
  toggleMedicalCardStatus(patient: any) {
    if (!patient.isMedicalCardActive) {
      this.changePatientActivationStatus(patient.phone);
    }
  }
  handleSearchPatients() {
    this.emergencyManagementService
      .searchLcaPatient(this.phoneNumber, this.pageSize, this.currentPage)
      .subscribe(
        (response: any) => {
          this.noMatchingResult = false;

          this.patientList = response?.data?.items;

          this.filteredPatientList = [...this.patientList];

          if (!this.filteredPatientList.length) {
            this.noMatchingResult = true;
          }

          this.currentPage = response?.data?.pagination.currentPage;
          this.totalPages = response?.data?.pagination.totalPages;
          this.totalItems = response?.data?.pagination.totalItems;
        },
        (error) => {
          this.noMatchingResult = true;
          this.filteredPatientList = [];
        }
      );
  }
  changePatientActivationStatus(phoneNumber: string) {
    this.emergencyManagementService.changePatientActivationStatus(phoneNumber)
      .subscribe({
        complete: () => {
          showNotification(
            'success',
            `Patient status changed successfully`,
            this.toastr
          );
          this.getAllPatients();
        }
      });
  }

  onChangePage(pageDetails: ISmartTablePagination) {
    this.currentPage = pageDetails.offset + 1;
    if (this.isSearchBtn) {
      this.handleSearchPatients();
    } else {
      this.getAllPatients();
    }
  }

  onSearchKeyup(phoneNumber) {
    if (!phoneNumber) {
      this.isSearchBtn = false;
      this.currentPage = 1;
      this.patientList = [];
      this.getAllPatients();
    }
  }

  onSearchSubmit(phoneNumber) {
    this.isSearchBtn = true;
    this.currentPage = 1;
    this.patientList = [];
    this.phoneNumber = phoneNumber;

    if (phoneNumber)
      this.handleSearchPatients();
  }

}
